/**
 * Testimonios de Baby Shower Dulce Recuerdo.
 *
 * ⚠️ ATENCIÓN: los tres testimonios de abajo son EJEMPLOS FICTICIOS DE DEMOSTRACIÓN
 * (`isDemo: true`). Sirven solo para evaluar el diseño. NO son opiniones reales
 * y NO deben publicarse como tales.
 *
 * Antes de publicar: reemplazá cada uno por un testimonio auténtico y verificado
 * de una clienta y cambiá `isDemo` a `false`. Mientras `isDemo` sea `true`,
 * la tarjeta muestra la etiqueta "Ejemplo de demostración".
 *
 * Si dejás `quote` vacío, se muestra el placeholder [TESTIMONIO REAL PENDIENTE].
 */
export type Testimonial = {
  title: string
  quote: string
  name: string
  detail: string
  /** true = ejemplo ficticio de demostración, no publicable */
  isDemo: boolean
  /** Nota interna: qué dolor representa (no se muestra) */
  painPoint?: string
}

export const babyShowerTestimonials: Testimonial[] = [
  {
    title: '¡Me resolvió todo!',
    quote:
      'No sabía qué juegos preparar y estaba perdiendo horas buscando ideas. Elegí mis favoritos, imprimí las hojas y pude dedicarme al resto del Baby Shower sin complicarme.',
    name: 'Camila',
    detail: 'Organizó el Baby Shower de su hermana',
    isDemo: true,
    painPoint: 'No saber qué juegos elegir y perder tiempo preparando la celebración.',
  },
  {
    title: '¡Todos se coparon!',
    quote:
      'Tenía miedo de que nadie participara, pero fue todo lo contrario. Nos reímos un montón, se sumaron todos y terminé disfrutando la fiesta tanto como los invitados.',
    name: 'Florencia',
    detail: 'Futura mamá',
    isDemo: true,
    painPoint: 'El miedo a que los invitados se aburran o no quieran participar.',
  },
  {
    title: 'Pude organizar todo sin estrés',
    quote:
      'Era la primera vez que organizaba un Baby Shower. La guía, los planes y el checklist me ayudaron a preparar todo y saber cómo dirigir los juegos.',
    name: 'Sofía',
    detail: 'Amiga de la futura mamá',
    isDemo: true,
    painPoint: 'No tener experiencia organizando y no saber cómo dirigir las actividades.',
  },
]
